import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Constants } from "../../Constants/ApiConstants";
import { AppConfig } from "../../api/config/config";

const OpenInApp = () => {
  const location = useLocation();
  const fullPath = location.pathname.replace("/open-in-app", "") || "/";
  const query = location.search;

  const appUrl = `myapp://${fullPath}${query}`;
  const fallbackWebUrl = `${AppConfig.WEB_APP_URL}${fullPath}${query}`;
  const playStoreUrl =
    "https://play.google.com/store/apps/details?id=com.ayatapps.domecaree.business";
  const appStoreUrl =
    "https://apps.apple.com/lb/app/domecare-clinic/id6743701023";

  const isAndroid = /Android/i.test(navigator.userAgent);
  const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  const [triedAutoOpen, setTriedAutoOpen] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setTriedAutoOpen(true);
    }, 1500);

    if (isAndroid) {
      window.location.href = `intent://${fullPath}${query}#Intent;scheme=myapp;package=com.yourcompany.yourapp;end`;
    } else if (isiOS) {
      window.location.href = appUrl;
    }

    return () => clearTimeout(timeout);
  }, [fullPath, query]);

  const handleOpenApp = () => {
    if (isAndroid) {
      window.location.href = `intent://${fullPath}${query}#Intent;scheme=myapp;package=com.yourcompany.yourapp;end`;
    } else if (isiOS) {
      window.location.href = appUrl;
    }
  };

  const handleGoToStore = () => {
    window.location.href = isAndroid ? playStoreUrl : appStoreUrl;
  };

  const handleContinueOnWeb = () => {
    window.location.href = fallbackWebUrl;
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16 text-center font-sans">
      <h2 className="mb-2 text-2xl font-bold">Open this page in the app</h2>
      <p className="mb-6 text-gray-600">
        We're trying to open the app automatically…
      </p>

      {triedAutoOpen && (
        <div className="flex flex-col gap-4">
          <button
            onClick={handleOpenApp}
            className="rounded-lg bg-green-600 px-6 py-3 text-base text-white hover:bg-green-700"
          >
            📱 Open in App
          </button>
          <button
            onClick={handleGoToStore}
            className="rounded-lg bg-blue-600 px-6 py-3 text-base text-white hover:bg-blue-700"
          >
            🛒 Get the App
          </button>
          <button
            onClick={handleContinueOnWeb}
            className="rounded-lg border bg-gray-100 px-6 py-3 text-base text-gray-800 hover:bg-gray-200"
          >
            🌐 Continue on Website
          </button>
        </div>
      )}
    </div>
  );
};

export default OpenInApp;
